export default __webpack_public_path__ + "static/media/drop-img.c8eb7b0b.png";